var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3314 6.8083C20.9628 6.8083 20.6632 7.10742 20.6632 7.47644V19.6766C20.6632 20.9659 19.6142 22.0149 18.3249 22.0149H3.67464C2.3855 22.0149 1.33629 20.9659 1.33629 19.6766V5.02626C1.33629 3.73683 2.3855 2.68785 3.67464 2.68785H18.3249C18.6941 2.68785 18.9931 2.38866 18.9931 2.01971C18.9931 1.65069 18.6943 1.35156 18.3249 1.35156H3.67464C1.64882 1.35162 0 3.00005 0 5.02621V19.6765C0 21.7027 1.64882 23.3512 3.67464 23.3512H18.3249C20.3514 23.3512 21.9996 21.7027 21.9996 19.6765V7.47638C21.9995 7.10748 21.7007 6.8083 21.3314 6.8083Z",
    fill: "#0F6901"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8032 0.845154C23.5423 0.584167 23.1187 0.584167 22.8586 0.845154L9.43349 14.2696L6.07795 10.9144C5.81702 10.6534 5.39413 10.6534 5.1332 10.9144C4.87227 11.1754 4.87227 11.5983 5.1332 11.8591L8.96176 15.6867C9.09231 15.8173 9.26327 15.8825 9.43417 15.8825C9.60512 15.8825 9.77613 15.8173 9.90657 15.6867L9.90725 15.6857L23.8032 1.78985C24.0642 1.52909 24.0642 1.10592 23.8032 0.845154Z",
    fill: "#0F6901"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicks);
export default __webpack_public_path__ + "static/media/ticks.b193bba413f89bdb0bbcb8a147c32f04.svg";
export { ForwardRef as ReactComponent };